<script setup>
	import { VAlert } from "vuetify/components";

	const props = defineProps({
		class: Array,
	});

	function getClasses() {
		if (!props.class)
			return ["mb-4", "critical-error-message"];
		else if (Array.isArray(props.class))
			return props.class.concat(['mb-4', 'critical-error-message']).join(" ");
		else if (typeof(props.class) === "string")
			return props.class.concat(" mb-4 critical-error-message");
	}
</script>

<template>
	<VAlert color="error" :class="getClasses()">
		<slot></slot>
	</VAlert>
</template>
